module.exports = __webpack_public_path__ + "img/17.a8973f2a.svg";